
import React from 'react';
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { TableEmptyState } from "@/components/admin/games/list/TableEmptyState";
import { MentoriaTableRow } from "./MentoriaTableRow";
import { MentoriaOffering } from "@/hooks/useMentoriasAdmin";

interface MentoriasTableProps {
  mentorias: MentoriaOffering[];
  searchTerm: string;
  onEdit: (mentoria: MentoriaOffering) => void;
  onViewDetails: (mentoria: MentoriaOffering) => void;
  onToggleStatus: (id: string, isActive: boolean) => void;
}

export const MentoriasTable: React.FC<MentoriasTableProps> = ({ 
  mentorias, 
  searchTerm, 
  onEdit,
  onViewDetails,
  onToggleStatus
}) => {
  if (mentorias.length === 0) {
    return (
      <TableEmptyState
        title="Nenhuma mentoria encontrada"
        description={searchTerm ? "Tente ajustar seu filtro de busca." : "Não há mentorias registradas no sistema."}
      />
    );
  }

  return (
    <div className="rounded-md border border-[#222A35] bg-[#181D24]">
      <Table>
        <TableHeader>
          <TableRow className="border-b border-[#222A35] hover:bg-transparent">
            <TableHead className="text-[#00B6F0]">Mentoria</TableHead>
            <TableHead className="text-[#00B6F0]">Mentor</TableHead>
            <TableHead className="text-[#00B6F0]">Jogo</TableHead>
            <TableHead className="text-[#00B6F0]">Preço</TableHead>
            <TableHead className="text-[#00B6F0]">Status</TableHead>
            <TableHead className="text-right text-[#00B6F0]">Ações</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {mentorias.map((mentoria) => (
            <MentoriaTableRow
              key={mentoria.id}
              mentoria={mentoria}
              onEdit={onEdit}
              onViewDetails={onViewDetails}
              onToggleStatus={onToggleStatus}
            />
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
